import React from "react";

const GanttChart = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M2 3.985h12.685v5.97H2v-5.97Zm18.426 0h6.235v5.97h-6.235v-5.97ZM8.45 11.34h6.235v5.97H8.45v-5.97Zm11.976 0h12.685v5.97H20.426v-5.97ZM4.151 18.69h10.535v5.97H4.151v-5.97Zm16.275 0h8.385v5.97h-8.385v-5.97ZM7.311 26.045h7.375v5.97H7.311v-5.97Zm13.115 0h11.556v5.97H20.426v-5.97ZM16.173 2h2.764v32h-2.764V2Z"
              fill={fill}
        />
    </svg>
);

export default GanttChart;